// src/App.jsx
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Layout } from 'antd';
import Header from './components/Header';
import Home from './pages/Home';
import PostCard from './pages/PostCard';
import Auth from './pages/Auth';
import Archive from './pages/Archive';
import About from './pages/About';
import WritePost from './pages/WritePost';
import PostDetail from './pages/PostDetail';
import { useEffect } from 'react';

const { Content } = Layout;

function App() {
  // 初始化用户数据（如果没有的话）
  useEffect(() => {
    const user = localStorage.getItem('user');
    if (!user) {
      localStorage.setItem('user', JSON.stringify({ name: '访客' }));
    }
  }, []);

  return (
    <BrowserRouter>
      <Layout style={{ minHeight: '100vh' }}>
        <Header />
        <Content style={{ marginTop: 64 }}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/postcard" element={<PostCard />} />
            <Route path="/write" element={<WritePost />} />
            <Route path="/auth" element={<Auth />} />
            <Route path="/archive" element={<Archive />} />
            <Route path="/about" element={<About />} />
            <Route path="/post/:id" element={<PostDetail />} />
          </Routes>
        </Content>
      </Layout>
    </BrowserRouter>
  );
}

export default App;